import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { type ListMediaAssetsParams, listMediaAssets } from '~/services/MediaService';

import { mediaAssetQueryKeys } from './mediaQueryKeys';

/**
 * Fetches a page of the media asset rate card.
 *
 * The previous page is kept on screen while the next one loads, so paging and searching do not
 * flash a spinner over rows that are about to be replaced.
 */
export function useGetMediaAssets(params: ListMediaAssetsParams) {
  return useQuery({
    queryKey: mediaAssetQueryKeys.list(params),
    queryFn: ({ signal }) => listMediaAssets(params, { signal }),
    placeholderData: keepPreviousData,
  });
}
